import React from "react";
import { Img } from "react-image";
import error from "./../Assets/error.jpg";
function ErrorPage() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "90vh",
      }}
    >
      <Img src={error} height={500} width={600} style={{ margin: "0" }} />
    </div>
  );
}

export default ErrorPage;
